module.exports = __webpack_public_path__ + "img/20.74370b78.png";